(function () {
  'use strict';

  /* global featurehubJsSdk */
  angular
    .module('FeatureFlagModule', [])
      .factory('FeaturehubJsSdk', () => featurehubJsSdk);
}());
